/**
 * Product name shown throughout the UI. Changing this single constant
 * renames the product everywhere — all translatable strings that reference
 * it do so via i18n interpolation with the `{{product}}` placeholder.
 */
export const PRODUCT_NAME = 'AO Patient Database'
